
























import { Vue, Component, Prop } from "vue-property-decorator";
import { FormattedRating } from "@/data/models/ProgramChainQualityRating";

@Component
export default class RatingOverviewComponent extends Vue {
  @Prop()
  label!: string;

  @Prop()
  formattedRatings!: FormattedRating[] | null;
}
